import { deleteAsync, getAsync, postAsync, putAsync } from "./ajax"
// 前台

export const requestHomeAsync = (data) => getAsync('/home', data)
// 轮播图列表
export const requestCarouselListAsync = () => getAsync('/carousel/carousel-list')
// 导航产品分类
export const requestCategoriesAsync = (data) => getAsync('/category/categories', data)
// 首页分类
export const requestHomeCategoriesAsync = () => getAsync('/category/home-category')
// 关于我们
export const requestAboutAsync = (data) => getAsync('/web-site/pc-content/335659373252677', data)
export const requestMobileAboutAsync = (data) => getAsync('/web-site/mobile-content/335659373252677', data)
// 联系我们
export const requestContactViewAsync = (data) => getAsync('/contact/view', data)
// 获取分类名称
export const requestBreadcrumbAsync = (data) => getAsync('/category/breadcrumb', data)
// 产品列表
export const requestProductViewListAsync = (data) => getAsync('/product/product-list', data)
// 产品详情
export const requestProductDetailAsync = (data) => getAsync('/product/product-detail', data)
// 发送询价
export const requestOrderInputAsync = (data) => postAsync('/order', data)
// 贴士列表
export const requestNewsViewListAsync = (data) => getAsync('/news/news-list', data)
// 贴士详情
export const requestTipsDetailAsync = (data) => getAsync('/news/news-detail', data)

// 后台

// 请求登录
export const requestLoginAsync = (data) => postAsync('/auth', data)
// 获取菜单列表
export const requestMenuListAsync = () => getAsync('/menu/menu-list')
// 联系方式
export const requestContactAsync = () => getAsync('/contact/333220650725445')
// 请求联系方式列表
export const requestContactListAsync = (data) => getAsync('/contact/list', data)
// 获取轮播图分页列表
// export const requestCarouselPageListAsync = (data) => getAsync('/carousel/list', data)
// 请求用户分页列表
export const requestUserListAsync = (data) => getAsync('/user/list', data)
// 添加用户
export const requestUserAdd = (data) => postAsync('/user', data)
// 删除用户
export const requestUserDelete = () => getAsync('/user/id')

// 请求信息分页列表
export const requestInformationListAsync = (data) => getAsync('/web-site/list', data)
// 请求新闻分页列表
export const requestTipsListAsync = (data) => getAsync('/news/list', data)
// 请求品牌分页列表
export const requestBrandListAsync = (data) => getAsync('/brand/list', data)
// 请求证书分页列表
export const requestCertListAsync = (data) => getAsync('/cert/list', data)
// 请求询价单分页列表
export const requestOrderListAsync = (data) => getAsync('/order/list', data)
// 请求客户反馈分页列表
export const requestFeedbackListAsync = (data) => getAsync('/feedback/list', data)
// 请求询价单
export const requestOrderAsync = (url) => getAsync(url)
// 请求分类列表
export const requestCategoryListAsync = (data) => getAsync('/category/admin-list', data)
// 后台一级分类
export const requestTopCategoriesAsync = (data) => getAsync('/category/top-categories', data)
// 后台全部分类
export const requestAllCategoriesAsync = (data) => getAsync('/category/all-categories', data)
// 后台产品分类
export const requestAdminCategoriesAsync = (data) => getAsync('/category/admin-categories', data)
// 请求产品列表
export const requestProductListAsync = (data) => getAsync('/product/list', data)

// 添加数据
export const requestAddAsync = (url, data) => postAsync(url, data)
// 编辑数据
export const requestEditAsync = (url, data) => putAsync(url, data)
// 删除数据
export const requestDeleteAsync = (url) => deleteAsync(url)
// 请求列表数据
export const requestListAsync = (url, data) => getAsync(url, data)
// 请求详情数据
export const requestModelAsync = (url) => getAsync(url)
// 获取枚举列表
export const requestEnumListAsync = (name) => getAsync(`/enum/${name}`)
// 上传文件
export const requestUploadAsync = (url, data, onUploadProgress) => postAsync(url, data, onUploadProgress)